import React, { useEffect, useState } from "react";
//import notification from "@crema/services/db/notifications";
import { IconButton } from "@mui/material";
import List from "@mui/material/List";
import Button from "@mui/material/Button";
//import AppScrollbar from "@crema/core/AppScrollbar";
import NotificationItem from "./NotificationItem";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { getNotifications } from "redux/actions/Home";
const AppNotificationContent = ({ onClose, sxStyle }) => {
    const dispatch = useDispatch();
    const { notificationsList } = useSelector((state) => state.homeReducer);
    const [limit, setLimit] = useState(10);
    let page = 0;
    useEffect(() => {
        dispatch(getNotifications(page, limit));
    }, [page, limit]);
    const loadMoreNotification = () => {
        setLimit(limit + 10);
    };
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                width: 360,
                height: "100%",
                ...sxStyle,
            }}
        >
            <Box
                sx={{
                    padding: "5px 20px",
                    display: "flex",
                    alignItems: "center",
                    borderBottom: 1,
                    borderBottomColor: (theme) => theme.palette.divider,
                    minHeight: { xs: 56, sm: 70 },
                }}
            >
                <Typography component="h3" variant="h3">
                    Notifications {""}
                    {notificationsList?.unReadCount > 0 &&
                        "(" + notificationsList?.unReadCount + ")"}
                </Typography>
                <IconButton
                    sx={{
                        height: 40,
                        width: 40,
                        marginLeft: "auto",
                        color: "text.secondary",
                    }}
                    onClick={onClose}
                    size="large"
                >
                    <CancelOutlinedIcon />
                </IconButton>
            </Box>
            <List sx={{ py: 0 }}>
                {notificationsList?.content?.content?.map((item) => (
                    <NotificationItem
                        key={item.id}
                        item={item}
                        onClose={onClose}
                    />
                ))}
            </List>
            {limit < notificationsList?.content?.totalElements && (
                <Box sx={{ p: 1 }}>
                    <Button
                        sx={{
                            borderRadius: "4px",
                            width: "100%",
                        }}
                        variant="contained"
                        color="primary"
                        onClick={loadMoreNotification}
                    >
                        Load more...
                    </Button>
                </Box>
            )}
            {notificationsList === null && (
                <Box>
                    <Typography sx={{ textAlign: "center", mt: 6 }}>
                        No Notification available...
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default AppNotificationContent;

AppNotificationContent.propTypes = {
    onClose: PropTypes.func,
    sxStyle: PropTypes.object,
};
